/**
 * Main JS file for Isola Tiberina.
*/
import { FCSlider } from './modules/fc-slider.js';
import { MainMenu } from './modules/main-menu.js';
import { easySmoothScroll } from './modules/smooth-scroll.js';
import { CustomScrollbar } from './modules/custom-scrollbars.js';
import { siteAnimations } from './modules/animations.js';
import { Spinner } from './modules/spinner.js';
import { Accordion } from "./modules/accordion";
import { SwiperJS } from './modules/swiper.js';

import 'bootstrap';

const SA = new siteAnimations();
const SP = new Spinner();
const AC = new Accordion();

const isolaGallery = new SwiperJS();

//const swiper = new SwiperJS();
//swiper.init_swiper();

// Main Menu
const MM = new MainMenu();

// Hero Slider
const FCS = new FCSlider();
FCS.heroSlider();

// Custom Scrollbar
const CSB = new CustomScrollbar();

// Smooth Scroll
const smoothScrollOptions = {
    element: '.scrolldown-link',
    speed: 500,
    offset: 0,
    backTopElement: '.back-top'
};
easySmoothScroll(smoothScrollOptions);

// Hide logo on scroll
let lastScrollTop = 0;
let hasScrolled = false;

jQuery(window).on('scroll', function () {

    const header = jQuery('#masthead');
    const scrollTop = jQuery(this).scrollTop();

    // ignora il primo evento di scroll (load)
    if (!hasScrolled) {
        hasScrolled = true;
        lastScrollTop = scrollTop;
        return;
    }

    // sotto i 150px header sempre normale
    if (scrollTop < 150) {
        header.removeClass('no-logo coloured-header');
        lastScrollTop = scrollTop;
        return;
    }

    // SCROLL VERSO L'ALTO → mostra header rosso
    if (scrollTop < lastScrollTop) {
        header.removeClass('no-logo');
        header.addClass('coloured-header');
    }

    // SCROLL VERSO IL BASSO → nascondi header
    if (scrollTop > lastScrollTop) {
        header.addClass('no-logo');
        header.removeClass('coloured-header');
    }

    lastScrollTop = scrollTop;
});
